/* Product cards: hover video loops (fine pointers only, lazily sourced), wishlist hearts. */

(() => {
  'use strict';

  /* Several sections include this file (a product page has main-product and recently-viewed),
     and every <script src> runs again. Bind once, or each heart click toggles twice. */
  const A = (window.antarti = window.antarti || {});
  if (A.cards) return;

  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- video loops --------------------------------------------------- */
  function bindVideos(root = document) {
    if (!hoverCapable) return;
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const video = card.querySelector('[data-card-video]');
      if (!video || card.dataset.videoBound) return;
      card.dataset.videoBound = '1';
      const play = () => {
        if (reduce.matches) return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        video.play().then(() => card.classList.add('is-playing')).catch(() => {});
      };
      const stop = () => {
        video.pause();
        card.classList.remove('is-playing');
      };
      card.addEventListener('pointerenter', play);
      card.addEventListener('pointerleave', stop);
      card.addEventListener('focusin', play);
      card.addEventListener('focusout', (e) => {
        if (!card.contains(e.relatedTarget)) stop();
      });
    });
  }

  /* --- wishlist hearts ----------------------------------------------- */
  function syncHearts(root = document) {
    const W = window.antarti && window.antarti.wishlist;
    if (!W) return;
    root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = W.has(btn.dataset.wishlistToggle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    const W = window.antarti && window.antarti.wishlist;
    if (!btn || !W) return;
    e.preventDefault();
    W.toggle(btn.dataset.wishlistToggle);
  });

  /* Cards arrive with the server's "not saved" heart. Anything that adds cards later
     (filters, pagination, recommendations, recently viewed) is synced here. */
  function sync(root = document) {
    bindVideos(root);
    syncHearts(root);
  }
  A.cards = { sync };

  document.addEventListener('antarti:wishlist', () => syncHearts());
  document.addEventListener('shopify:section:load', (e) => sync(e.target));
  document.addEventListener('antarti:collection', (e) => sync(e.detail?.section || document));
  document.addEventListener('antarti:recommendations', (e) => sync(e.detail?.section || document));

  /* Catch-all for cards inserted without an event (e.g. the recently viewed rail). */
  const cardSelector = '[data-product-card], [data-wishlist-toggle]';
  const hasCard = (n) => n.nodeType === 1 && (n.matches(cardSelector) || !!n.querySelector(cardSelector));
  new MutationObserver((records) => {
    const parents = new Set();
    records.forEach((r) => {
      if (Array.from(r.addedNodes).some(hasCard)) parents.add(r.target);
    });
    parents.forEach((p) => p.isConnected && sync(p));
  }).observe(document.body, { childList: true, subtree: true });

  sync();
})();
